<p-toast key="top-right" [baseZIndex]="99999"></p-toast>
<p-confirmDialog></p-confirmDialog>
<div class="pages-body login-page flex flex-column">
    <div class="align-self-center mt-auto mb-auto">
        <div class="pages-panel card flex flex-column">
            <div class="pages-header px-3 py-1">
                <h2 style="font-family: 'Audiowide'; font-size: 4rem;">FINEXUS</h2>
            </div>
            
            <h4>Bienvenido</h4>
            
            <div class="pages-detail mb-6 px-6">Porfavor ingrese su usuario y contraseña para iniciar sesión</div>
            
            <form [formGroup]="formGroup" (ngSubmit)="login()">
                <div class="input-panel flex flex-column px-3">
                    <div class="p-inputgroup">
                        <span class="p-float-label">
                            <input formControlName="usuario" type="text" id="usuario" pInputText [ngClass]="formGroup.get('usuario').invalid ? 'ng-dirty ng-invalid' : ''">
                            <label for="usuario">Usuario</label>
                        </span>
                        <span class="p-inputgroup-addon">
                            <i class="pi pi-user"></i>
                        </span>
                    </div>
                    <small *ngIf="invalidControl('usuario')" style="color: red;">Este campo es requerido.</small>
    
                    <div class="p-inputgroup mt-3">
                        <span class="p-float-label p-input-icon-right">
                            <input formControlName="password" [type]="passType" id="password" pInputText [ngClass]="formGroup.get('password').invalid ? 'ng-dirty ng-invalid' : ''">
                            <label for="password">Contraseña</label>
                        </span>
                        <span class="p-inputgroup-addon">
                            <i *ngIf="passType==='password'" class="pi pi-lock" (click)="showPassword('text')"></i>
                            <i *ngIf="passType==='text'" class="pi pi-lock-open" (click)="showPassword('password')"></i>
                        </span>
                    </div>
                    <small *ngIf="invalidControl('password')" style="color: red;">Este campo es requerido.</small>
                    <div class="field-checkbox mt-3">
                        <p-checkbox name="recordar" id="recordar" [binary]="true" formControlName="recordar"></p-checkbox>
                        <label for="recordar">Recordar Usuario</label>
                    </div>
                    <p-button type="submit" class="login-button mt-2 mb-6 px-3" label="INGRESAR" [loading]="loading" loadingIcon="pi pi-sync pi-spin"></p-button>
                </div>
            </form>
        </div>
    </div>
    <div class="flex justify-content-end">
        <span style="color: white; font-size: 0.8rem;">Version: {{ version }} - Fecha: {{ fecha }}</span>
    </div>
</div>
